<template>
  <div class="ticket">
    <transition name="modal-fade-scale">
      <app-modal @close="close" v-if="getModal">
        <app-modal-default @close="close" class="add-ticket" >
          <template v-slot:header>
            {{ $ml.get(`Create new ticket`) }}
          </template>
          <template v-slot:content>
            <div class="form">
              <app-text-input :label="$ml.get(`Contact email`)" v-model="email"/>
              <app-text-input :label="$ml.get(`Subject`)" v-model="subject"/>
              <app-textarea :label="$ml.get(`Message`)" v-model="message"/>
              <ImageInput @input="onFileUpload"/>
              <app-btn :loading="loading" @click="create">{{ $ml.get(`Submit`) }}</app-btn>
            </div>
          </template>
        </app-modal-default>
      </app-modal>
    </transition>
    <template v-if="$route.params.ticketId">
      <h1>{{ $ml.get(`Ticket`) }} # {{ $route.params.ticketId }}</h1>
      <aside class="ticket-block" v-if="item">
        <div class="is-opened">
          <h2 class="is-opened-header" disalbed="!loading"><b>{{ item.subject}}</b></h2>
          <p>
            <span class="orange" :class="{green : item.status === 'opened'}">
              {{item.status === 'opened'? $ml.get(`opened`).toUpperCase() : $ml.get(`closed`).toUpperCase() }}
            </span>
          </p>
        </div>
        <app-devider/>
        <!-- TODO добавить перевод -->
        <h2>Question: </h2>
        <p class="message"> {{ item.message }} </p>
        <h2 v-if="item.answer != ''">Answer: </h2>
        <p class="message" v-if="item.answer != ''"> {{ item.answer }} </p>
      </aside>

    </template>
  </div>
</template>

<script>
import API from '@/api'
import { FileAPI } from '@/api'
import ImageInput from '@/components/common/ImageInput'
import {mapGetters} from 'vuex'

  export default {
    name: "Ticket",
    components: {
      ImageInput,
    },
    data() {
      return {
        subject: '',
        message: '',
        email: '',
        file: '',
        item: {},
        loading: false,
      }
    },

    computed: {
      ...mapGetters(
        {getModal: 'getModal'}
      )
    },

    watch: {
      $route(to, from) {
        this.select();
      }
    },

    created() {
      this.select();
      // console.log(this.getters);
      this.email = this.$store.getters['user/data'].email;
    },

    methods: {
      async onFileUpload(file) {
        this.file = await FileAPI.upload(file)
          .then(res => res.data.id);
      },
      close() {
        this.$store.commit('closeModal');
      },
      create() {
        if (!this.subject && !this.message) {
          return this.$notify({
            group: 'notices',
            title: `Fill all fields`,
            type: 'error',
          });
        }
        this.loading = true;

        return API.tickets.create(this.subject, this.message, this.email, this.file)
          .then(res => {
            if (res.data.success) {
              this.$router.push(`/dashboard/support/ticket/${res.data.data.id}`);
              this.$emit('sync');
              this.$notify({
                group: 'notices',
                title: this.$ml.get(`Your ticket was successfully sent!`),
                type: 'success',
              });
              this.message = '';
              this.subject = '';
            }
          })
          .finally(() => {
            this.loading = false;
            this.$store.commit('closeModal')
            this.$store.dispatch("getTickets")
            this.$store.dispatch('isViewed');
          })
      },
      select() {
        if (this.$route.params.ticketId !== 'new') {
          return API.tickets.select(this.$route.params.ticketId)
            .then(res => {
              this.item = res.data.data;

              this.$store.dispatch("viewed", this.$route.params.ticketId);
            })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .ticket-block {
    min-width: 100%;
    border: 1px #E4E5E6 solid;
  }

  .is-opened {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px #E4E5E6 solid;

    p {
      margin: 0;
    }

    &-header {
      margin: 0 28px 0 0;
      font-style: normal;
      font-weight: bold;
      font-size: 33px;
      line-height: 33px;
    }

    .orange {
      font-style: normal;
      font-weight: bold;
      font-size: 10px;
      line-height: 12px;
      display: block;
      padding: 5px;
      background: #F2B14E;
      border-radius: 3px;

    }

    .green {
      background: $mainGreen;
      color: #fff;
    }
  }

  .message {
    padding: 20px 27px;
    background-color: #F7F7F7;
    border-radius: 5px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
    max-width: 502px;
    color: #000000;
  }

  .ticket {
    padding: 0 8px;
    height: fit-content;

    .form {

      textarea {
        width: 100%;
        height: 200px;
        border-radius: 3px;
        border: 1px solid $mainGreen;
      }


      > * {
        &:nth-child(3) {
          height: 200px;
        }

        margin-top: 32px;
      }
    }

    @media(max-width: 768px) {
      .form {
        max-width: 100%;
      }
    }
  }

  .add-ticket {
    width: 400px;
    .form {
      width: 100%;
    }
  }

</style>
